import "core-js/modules/es.array.push.js";
const ERROR_CODES = new Map([['U', 'order.checkout.under.submission.errormessage'], ['C', 'order.checkout.creditcard.errormessage']]);
import DcModal from '../../../ui/modal/DcModal.vue';
import LoadingDots from '@/dow-platform/components/commerce/shared/loading-dots/index.js';
import { ChevronIcon } from '../../blocks/svg-elements/chevron-icon';
import PoSummaryItem from './po-summary-item.vue';
import ApiClient from '@/plugins/AxiosPlugin';
import { UserHelper } from '@/helpers/user-helper';
export default {
  name: 'CheckoutSummary',
  props: {
    checkoutData: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      showCancelCheckoutModal: false,
      showProcessingModal: false,
      showErrorModal: false,
      errorMessage: '',
      ordersLink: 'my-account.html#/my-orders',
      isCartCheckoutOrderSummaryAmountFromEccEnabled: window.isCartCheckoutOrderSummaryAmountFromEccEnabled || false
    };
  },
  components: {
    DcModal,
    LoadingDots,
    ChevronIcon,
    PoSummaryItem
  },
  computed: {
    isIndia: function () {
      return this.checkoutData?.isIndia;
    },
    isExchangeMessage: function () {
      return this.checkoutData?.isExchangeMessage;
    },
    totalsByPo: function () {
      if (self.isCartCheckoutOrderSummaryAmountFromEccEnabled) {
        if (this.checkoutData?.totalsByPoCheckout) {
          return this.checkoutData.totalsByPoCheckout.map(po => ({
            poNumber: po.poNumber,
            totalsByCurrency: po.totalsByPoList.map(currencyType => ({
              currency: currencyType.currency,
              subtotal: currencyType.totalsByCurrency.subtotalAmountFormatted,
              subtotalRaw: currencyType.subtotal,
              discount: currencyType.totalsByCurrency.discountAmount ? currencyType.totalsByCurrency.discountAmountFormatted : undefined,
              surcharge: currencyType.totalsByCurrency.surchargeAmount ? currencyType.totalsByCurrency.surchargeAmountFormatted : undefined,
              tax: currencyType.totalsByCurrency.taxAmountFormatted,
              total: currencyType.totalsByCurrency.totalAmountFormatted,
              totalRaw: currencyType.totalsByCurrency.totalAmount,
              fee: currencyType.totalsByCurrency.feeAmountFormatted
            })),
            expanded: false
          }));
        }
      } else {
        if (this.checkoutData?.totalsByPo) {
          return this.checkoutData.totalsByPo.map(po => ({
            poNumber: po.poNumber,
            totalsByCurrency: po.totalsByPoList.map(currencyType => ({
              currency: currencyType.currency,
              subtotal: currencyType.totalsByCurrency.checkoutSubtotalAmountFormatted,
              subtotalRaw: currencyType.subtotal,
              discount: currencyType.totalsByCurrency.discountAmount ? currencyType.totalsByCurrency.discountAmountFormatted : undefined,
              surcharge: currencyType.totalsByCurrency.surchargeAmount ? currencyType.totalsByCurrency.surchargeAmountFormatted : undefined,
              tax: currencyType.totalsByCurrency.taxAmountFormatted,
              total: currencyType.totalsByCurrency.totalAmountFormatted,
              totalRaw: currencyType.totalsByCurrency.totalAmount,
              fee: currencyType.totalsByCurrency.feeAmountFormatted
            })),
            expanded: false
          }));
        }
      }
      return [];
    },
    canCreateOrders() {
      return UserHelper.isUserHasCreateOrderAccess();
    }
  },
  methods: {
    getLabel: function (key) {
      return window.Granite.I18n.get(key);
    },
    completeCheckout() {
      this.loading = true;
      this.showProcessingModal = true;
      const url = this.$store.state.settings.create_order_servlet;
      ApiClient.post(url, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(async resp => {
        const response = resp.data;
        this.loading = false;
        this.showProcessingModal = false;
        if (response.errorDetails?.errorCode && response.errorDetails.errorCode != 'T') {
          if (response.errorDetails.errorCode == '406') {
            await this.resetCartCount();
            window.location.href = this.ordersLink;
          } else {
            this.errorMessage = this.getLabel(ERROR_CODES.get(response.errorDetails.errorCode) ?? 'order.checkout.payment.generalErrorModal.content');
            this.showErrorModal = true;
          }
        } else {
          this.$store.commit('cart/setConfirmationData', response);
          let orderNo = response.orderCarts?.[0]?.orderNo || '';
          if (orderNo) {
            this.analyticsTracking(orderNo);
          }
          await this.resetCartCount();
          this.$router.push({
            name: 'confirmation'
          });
        }
      }).catch(error => {
        this.loading = false;
        this.showProcessingModal = false;
        console.error('Error', error);
        this.errorMessage = this.getLabel('deliveryDetails.page.trackDelivery.error');
        this.showErrorModal = true;
      });
    },
    toggleCancelCheckoutModal() {
      this.showCancelCheckoutModal = !this.showCancelCheckoutModal;
    },
    toggleErrorModal() {
      this.showErrorModal = !this.showErrorModal;
    },
    returnToCart() {
      this.toggleCancelCheckoutModal();
      this.$router.push({
        name: 'cart'
      });
    },
    resetDropdowns(poNumber) {
      this.$refs.PoItems.forEach(poItem => {
        if (poItem.poNumber == poNumber || poItem.isExpanded) {
          poItem.toggleIsExpanded();
        }
      });
    },
    analyticsTracking(orderNo) {
      let productList = this.checkoutData.entries.map(entry => ({
        gmid: entry.materialNumber || 'unavailable',
        SKU: entry.materialNumber || 'unavailable',
        name: entry.product.name,
        quantity: entry.quantity,
        lineItemTotal: entry.totalPrice.formattedValue,
        poNumber: entry.lineItemPO,
        headerPOUsed: localStorage.getItem('headerPOUsed') || false,
        distinctPONumberCount: this.totalsByPo.length
      }));
      localStorage.setItem('productList', JSON.stringify(productList));
      this.$store.dispatch('pdp/purchaseTracking', {
        orderId: orderNo,
        cartGuid: this.checkoutData.guid,
        products: productList
      });
    },
    async resetCartCount() {
      // Reset cart count
      var purchaseCartCount = new FormData();
      purchaseCartCount.append('number', '0');
      await ApiClient.post('/.dow.purchase.cart.count.json', purchaseCartCount, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      this.$store.state.user.dccUserInfo.data.numberOfCartItems = 0;
    }
  }
};